export enum TopologyElementType {
  connection = 'connection',
  peerConnection = 'peerConnection',
  node = 'node',
  voipPeer = 'voipPeer',
  voipPeers = 'voipPeers',
  offlineNodes = 'offlineNodes',
  offlineVoipPeers = 'offlineVoipPeers',
  offlineConnections = 'offlineConnections',
  offlinePCons = 'offlinePCons',
  connections = 'connections',
  nodes = 'nodes',
  pCons = 'pCons',
  cluster = 'cluster'
}
